import { render, staticRenderFns } from "./private-sales-genre.vue?vue&type=template&id=8620249e&scoped=true&"
import script from "./private-sales-genre.vue?vue&type=script&lang=js&"
export * from "./private-sales-genre.vue?vue&type=script&lang=js&"
import style0 from "./private-sales-genre.vue?vue&type=style&index=0&id=8620249e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8620249e",
  null
  
)

export default component.exports